import { get } from 'lodash';
import bottlebooksFieldsSource from './bottlebooksFieldsSource.json'
// import { allSupportedLocales } from '@bottlebooks/valid-values';
const allSupportedLocales = ['en', 'pt', 'es', 'fr', 'de', 'it', 'nl', 'pl'];
/**
 * TODO 1 This definition could be done in TS. Should it be part of valid-values project?
 * TODO We should start with pure elabels import. So this could go under elabelDataImport import type
 */
export const elabelFields = bottlebooksFieldsSource
  .reduce((acc, configuration) => {
    acc = expandConfiguration({ acc, configuration });
    return acc;
  }, [])
  .map(({ path, label }) => ({
    key: path.replace('draft.', 'eLabel.'),
    label,
  }));

function expandConfiguration({ acc, configuration }) {
  const fieldMaxEntries = 1;
  if (configuration.formFields) {
    for (let i = 0; i < fieldMaxEntries; i++) {
      if (configuration.formFields) {
        configuration.formFields.forEach((subConf) => {
          acc = processOneConfiguration(acc, subConf, i);
        });
      } else {
        acc = processOneConfiguration(acc, configuration, i);
      }
    }
  } else {
    for (let i = 0; i < fieldMaxEntries; i++) {
      acc = processOneConfiguration(acc, configuration, i);
    }
  }
  return acc;

  function processOneConfiguration(acc, subConf, i) {
    if (subConf.type === 'translations') {
      allSupportedLocales.forEach((locale) => {
        //@ts-ignore
        acc.push({
          ...subConf,
          path: subConf.path.replace('.0.', `.${i}.`) + `.${locale}`,
          header: subConf.header.replace('.0.', `.${i + 1}.`) + `.${locale}`,
          label: subConf.label
            .replace('{0}', ``)
            .replace('{locale}', `(${locale})`),
        });
      });
    } else {
      // @ts-ignore
      acc.push({
        ...subConf,
        path: subConf.path.replace('.0.', `.${i}.`),
        header: subConf.header.replace('.0.', `.${i + 1}.`),
        label: subConf.label.replace('{0}', ``),
      });
    }
    return acc;
  }
}

/**
 * Will count how many time a field repeats.
 * Count arrays maximum size for all elabels. All the other fields count should be 1.
 * @param {*} eLabels
 * @returns
 */
function getFieldCounters(eLabels) {
  return elabelFields.reduce((acc, field) => {
    return processFieldCounter({ acc, field });
  }, {});

  function processFieldCounter({ acc, field }) {
    const { path, formFields } = field;
    const maximum = eLabels?.reduce((max, eLabel) => {
      const value = get(eLabel, path);
      //Object array
      if (formFields?.length) {
        const elabelFieldCount = value?.length;
        if (elabelFieldCount > max) max = elabelFieldCount;
      }
      //array
      if (Array.isArray(value)) {
        if (value?.length > acc[path]) acc[path] = value?.length;
      }
      return max;
    }, 1);
    acc[path] = maximum;
    return acc;
  }
}
